import Axios from 'axios';
import { getCookie } from '@/shared/lib/helpers/cookies';
// eslint-disable-next-line import/no-cycle
import store from '@/app/store';

const headers = {
	'Content-Type': 'application/json',
	// 'Authorization': `Bearer ${getCookie('tokenOperator')}`
	Authorization: `Bearer ${getCookie('token')}`,
	'authorization-jwt': `Bearer ${getCookie('token')}`,
};

Axios.interceptors.response.use(
	(response) => response,
	(e) => {
		console.log('AXIOS I REJECT:', e.response);
		if (e.response?.data?.status === false && e.response?.status === 401) {
			console.log('INTERCEPTOR LOGOUT');
			store.commit('LOGOUT');
		}
		return Promise.reject(e);
	},
);
const api = async (method, path, data, responseType) => {
	const options = {
		method,
		url: path,
		headers,
	};
	// eslint-disable-next-line no-unused-expressions
	method === 'post' || method === 'put' ? options.data = data || {} : '';
	if (method === 'get') {
		options.data = {};
	}
	if (responseType) {
		options.responseType = responseType;
	}
	// eslint-disable-next-line no-useless-catch
	try {
		return await Axios(options);
	} catch (e) {
		throw e.response;
	}
};

export const getApi = (path, responseType) => api('get', path, {}, responseType);
export const deleteApi = (path) => api('delete', path);
export const postApi = (path, jsonData) => api('post', path, jsonData);
export const putApi = (path, jsonData) => api('put', path, jsonData);
